import { useState, Fragment, useEffect } from "react";
import { themeStyle } from "../components/Components.js";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import {
  API_URL,
  MAIN_TITLE,
  alertMessage,
  DOMAIN_URL,
  SIDEBAR,
  ONLYLOGO,
  APPBAR,
  GRADIENT,
} from "../actions/auth.js";
import Typography from "@mui/material/Typography";
import { loadStudent } from "../actions/auth.js";
import CardActionArea from "@mui/material/CardActionArea";
import { useSelector, useDispatch } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Snackbar from "@mui/material/Snackbar";
import Card from "@mui/material/Card";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import IconButton from "@mui/material/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
function Copyright() {
  return (
    <Typography variant="body2" color="white" align="center">
      {"Copyright © "}
      {MAIN_TITLE + " "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function StudentSelection() {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [showSnack, setShowSnack] = useState(false);
  const [snack, setSnack] = useState("");
  const [clearText, setClearText] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  function loadiStudent(studentUserId) {
    console.log(studentUserId);
    setIsLoggingIn(true);
    dispatch(loadStudent(studentUserId, state.auth.user.user_id));
  }

  if (state.auth.alert) {
    if (state.auth.alert.title == "Welcome!") {
    } else {
      setSnack({
        title: state.auth.alert.title,
        message: state.auth.alert.message,
        type: state.auth.alert.type,
      });
      setShowSnack(true);
      dispatch({ type: "REMOVE_ALERT" });
    }
  }

  if (!state.auth.isLoadingStudent) {
    return <Navigate to="/" />;
  }
  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        autoHideDuration={6000}
        open={showSnack}
        onClose={() => setShowSnack(false)}
      >
        <Card style={{ minWidth: "350px", padding: "10px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex" }}>
              {snack["type"] == "SUCCESS" ? (
                <CheckCircleIcon
                  style={{ color: "#2ca25f", fontSize: "44px" }}
                />
              ) : snack["type"] == "MESSAGE" ? (
                <ErrorIcon
                  style={{ color: themeStyle.primaryColor, fontSize: "44px" }}
                />
              ) : (
                <ErrorIcon style={{ color: "#ff3333", fontSize: "44px" }} />
              )}
              <div style={{ marginLeft: "10px" }}>
                <b style={{ fontSize: "15px" }}>{snack["title"]}</b>
                <br></br>
                <span>{snack["message"]}</span>
              </div>
            </div>
            <IconButton size="small" onClick={() => setShowSnack(false)}>
              <CloseIcon style={{ color: themeStyle.primaryColor }} />
            </IconButton>
          </div>
        </Card>
      </Snackbar>
      <AppBar
        position="fixed"
        style={{
          backgroundColor: "white",
        }}
      >
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
            <img
              style={{ maxHeight: "50px", margin: "10px" }}
              src={require("../img/" + APPBAR)}
            />
          </a>
        </Toolbar>
      </AppBar>
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "opacity 1s",
          opacity: loaded ? 1 : 0,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundImage: GRADIENT,
            height: "100%",
            paddingTop: "50px",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              boxShadow: "0 8px 18px 0 rgba(0,0,0,0.2)",
              padding: "50px",
              borderRadius: "16px",
              backgroundColor: "white",
              minWidth: "20vw",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                color: "black",
              }}
            >
              <img
                style={{
                  maxHeight: "100px",
                  marginLeft: "-5px",
                }}
                src={require("../img/" + APPBAR)}
              />
            </div>
            <div
              className={state.auth.alert ? "shake" : ""}
              style={{
                height: "20px",
                marginTop: "15px",
                textAlign: "center",
                color: "#ff3333",
              }}
            >
              {state.auth.alert
                ? state.auth.alert.type == "ERROR"
                  ? state.auth.alert.message
                  : ""
                : ""}
            </div>
            <div
              style={{
                margin: "5px 0px 0px 0px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                {JSON.parse(state.auth.user.student_email_list).map(
                  (student, index) => {
                    return (
                      <CardActionArea
                        onClick={() => loadiStudent(student["user_id"])}
                        sx={[
                          {
                            borderRadius: "6px",
                            border:
                              "1.5px solid " + themeStyle.primaryColorLight,
                            transition:
                              "background-color 0.5s, border-color 0.5s",
                          },
                          (theme) => ({
                            "&:hover": {
                              backgroundColor: "#ebf5ff",
                              borderColor: themeStyle.primaryColor,
                            },
                            ".MuiCardActionArea-focusHighlight": {
                              background: "transparent",
                            },

                            "&& .MuiTouchRipple-child": {
                              backgroundColor: "#084594",
                            },
                          }),
                        ]}
                        style={{
                          padding: "7px",
                          width: "30vw",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            padding: "20px",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "-25px",
                              color: themeStyle.primaryColor,
                            }}
                          >
                            <h1>{student["name"]}</h1>
                            <div
                              style={{
                                marginTop: "-10px",
                                color: "black",
                                textAlign: "center",
                              }}
                            >
                              Student Id:<b> {student["user_id"]}</b>
                            </div>
                          </div>
                        </div>
                      </CardActionArea>
                    );
                  }
                )}
              </div>
              {isLoggingIn ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <CircularProgress />{" "}
                </div>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </div>
        <Box style={{ position: "absolute", right: 20, bottom: 20 }}>
          <Copyright />
        </Box>
      </div>
    </Fragment>
  );
}
